class CapViewAllVendors {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_all_vendors'
}

function create(config) {
  return new CapViewAllVendors(config)
}

export default {
  key,
  create,
}